import React, { useEffect, useState } from 'react';
import { settingGet } from '../../../utils/settingApi';
import {
  diaChile, nombreDia, textoEvento, etiquetaAccion, fechaHora,
} from '../../../utils/settingFormato';

// Actividad (spec §5.4): lo que hizo Julio hoy y los días anteriores, hora por hora, desde los eventos. Abajo, los
// cambios hechos en el panel y cómo terminaron. El admin filtra por quién y por el correo de quien hizo el cambio.
const QUIENES = [['julio', 'Julio'], ['agustin', 'Agustín'], ['panel', 'Panel'], ['todos', 'Todos']];

const textoCambio = (c, usuarios) => [
  fechaHora(c.fecha),
  `${etiquetaAccion(c.accion)}${c.valor ? ` (${c.valor})` : ''}`,
  `@${usuarios[c.conv_id] || c.conv_id}`,
  c.quien,
  `${c.estado}${c.motivo ? `: ${c.motivo}` : ''}`,
].join(' · ');

const ActividadSetting = ({ esAdmin, vuelta, usuarios }) => {
  const [quien, setQuien] = useState('julio');
  const [correo, setCorreo] = useState('');
  const [datos, setDatos] = useState(null);
  const [cambios, setCambios] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    let vivo = true;
    Promise.all([settingGet(`actividad?dias=7&quien=${quien}`), settingGet('cambios')])
      .then(([a, c]) => {
        if (!vivo) return;
        setDatos(a);
        setCambios(c.cambios || []);
        setError('');
      })
      .catch((e) => { if (vivo) setError(e?.response?.data?.error || 'No pude cargar la actividad.'); });
    return () => { vivo = false; };
  }, [quien, vuelta]);

  const hoy = diaChile();
  const correos = [...new Set(cambios.map((c) => c.quien))];
  const visibles = correo ? cambios.filter((c) => c.quien === correo) : cambios;

  return (
    <div className="au-set-actividad">
      <section className="au-set-card">
        <h2 className="au-set-titulo">Lo que se hizo, hora por hora</h2>
        {esAdmin && (
          <div className="au-set-filtros">
            <select aria-label="Quién" value={quien} onChange={(e) => setQuien(e.target.value)}>
              {QUIENES.map(([clave, etiqueta]) => <option key={clave} value={clave}>{etiqueta}</option>)}
            </select>
          </div>
        )}
        {error && <p className="au-set-error" role="alert">{error}</p>}
        {datos && datos.dias.length === 0 && <p className="mono muted">Sin actividad en los últimos 7 días.</p>}
        {(datos?.dias || []).map((d) => (
          <div key={d.dia} className="au-set-dia">
            <h3>{nombreDia(d.dia, hoy)} <span className="mono muted">{`${d.total} eventos`}</span></h3>
            {d.horas.map((h) => (
              <div key={h.hora} className="au-set-hora">
                <span className="mono">{`${h.hora} h`}</span>
                <ul>
                  {h.eventos.map((e) => <li key={e.id}>{`${e.hora} @${e.usuario}: ${textoEvento(e)}`}</li>)}
                </ul>
              </div>
            ))}
          </div>
        ))}
      </section>
      <section className="au-set-card">
        <h2 className="au-set-titulo">Cambios desde el panel</h2>
        {esAdmin && (
          <div className="au-set-filtros">
            <select aria-label="Cambios de" value={correo} onChange={(e) => setCorreo(e.target.value)}>
              <option value="">Todos</option>
              {correos.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        )}
        <ul className="au-set-linea">
          {visibles.map((c) => <li key={c.id}>{textoCambio(c, usuarios)}</li>)}
        </ul>
      </section>
    </div>
  );
};

export default ActividadSetting;
